var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.069,
    height: 32.202,
    viewBox: "0 0 83.069 32.202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98209",
    "data-name": "Group 98209",
    transform: "translate(-316.94 -702)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215449",
    "data-name": "Path 215449",
    d: "M-2691.06,6407l11.556,15.464-11.2,16.738h82.711V6407Z",
    transform: "translate(3008 -5705)",
    fill: "#f07721"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Used",
    transform: "translate(338.884 724.804)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "AvenirLTStd-Heavy, Avenir LT Std",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Used")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsed);
export default __webpack_public_path__ + "static/media/used.3b2a833499a24a84c22152310a0f841a.svg";
export { ForwardRef as ReactComponent };